<template>
<!--  <Breadcrumb />-->
  <div class="course">
    <!-- 视频部分免费试看 -->
    <VideoPlayer
      :data_isShowPlayer_b="isShowPlayer_b"
      :data_videoInfo="videoInfo_o"
      :data_payVideo="payVideo"
      v-model:data_vid="vid"
      :data_isCollect_fn="videoCollect_fn"
      :data_isCollect_b="isCollect_b"
    />
    <!-- 列表部分-->
    <VideoInfo
      :data_isPay_b="isPay_b"
      :data_isShowPlayer_b="isShowPlayer_b"
      :data_videoInfo="videoInfo_o"
      :data_payVideo="payVideo"
      v-model:data_vid="vid"
      :data_isCollect_fn="videoCollect_fn"
      :data_isCollect_b="isCollect_b"
      :data_limitTime_countDown_text="limitTime_countDown_text"
    />
  </div>
  <!-- 标签栏 -->
  <div class="tabList">
    <nav>
      <ul>
        <li
          v-for="(item, index) in tab_o.tabs"
          @click="setTab_fn(index, $event)"
          :class="tab_o.activeTab === index ? 'active' : ''"
          :key="index"
        >
          {{ item }}
        </li>
      </ul>
      <div class="tabsLine" ref="tabsLine"></div>
    </nav>
  </div>
  <!-- 课程信息 -->
  <div class="content">
    <!-- tab页 -->
    <Tabpanel
            :data_index="tab_o.activeTab"
            :data_videoInfo="videoInfo_o"
            :data_payVideo="payVideo"
            v-model:data_vid="vid"
            :data_isScore_b="isScore_b"
            :data_userId="userId"
    />
    <!-- 右边 讲师和相关推荐 -->
    <CourseOutherInfo :videoInfo_o="videoInfo_o" :curriculumId="curriculumId"/>
  </div>

  <Certificate/>
  <LuckyDraw/>
  <Service v-if="curriculumId === '2207' || curriculumId === '2208'"/>
</template>

<script>
import VideoInfo from "@c/course/VideoInfo.vue";
import VideoPlayer from "@c/course/VideoPlayer.vue";
import CourseOutherInfo from "@c/course/CourseOutherInfo.vue";
import Certificate from "@c/course/Certificate.vue"; // 证书
import Service from "@c/course/Service.vue"; // 客服
import Tabpanel from "@c/course/Tabpanel.vue";
import Breadcrumb from "@c/Breadcrumb.vue";
import { getCourseDetail, getUserCourseStatus, courseCollect, savePlayRecord ,saveBrowsingHistory} from "@/api";
import { syslogin,getUserId } from "@/utils/methods";
import {message,Modal} from "ant-design-vue";
import {baseUrl} from "@/api/config";
import {add_to_favorite} from "../../utils/AnalysysAgent";
import LuckyDraw from "@c/course/LuckyDraw.vue"; // 抽奖部分记和样式

export default {
  name: "course",
  components: {
    VideoInfo,
    VideoPlayer,
    Certificate,
    Tabpanel,
    Breadcrumb,
    Modal,
    LuckyDraw,
    Service,
    CourseOutherInfo
  },
  data() {
    return {
      userId:getUserId(),
      isShowPlayer_b: false, // 是否显示播放器
      isPay_b: false, // 是否支付
      vid:'', // 播放器vid
      videoId:"",// 课程视频ID
      curriculumId: this.$route.query.courseId?this.$route.query.courseId:this.$route.params.videoId, // 课程ID
      tab_o: {
        tabs: ["课程介绍", "课程目录", "课程评价"],
        activeTab: 0, // tabIndex
      },
      isPlay_b: false, // 该课程是否切出课程
      videoInfo_o: {}, // 视频信息
      isToOrderPage_b: false, // 购买功能是否开启
      // 是否关注
      isCollect_b: false,
      // 该用户是否已评分
      isScore_b: false,
      // 实际购买状态
      userCourseStatus_copy: null,
      // 限免倒计时
      limitTime_countDown_time: null,
      // 倒计时时间文本
      limitTime_countDown_text: '',
    };
  },
  methods: {
    // tabs按钮
    setTab_fn(tab, ev) {
      if(!this.videoInfo_o.name) return;
      this.tab_o.activeTab = tab;
      this.$refs.tabsLine.style.left =
        ev.target.offsetLeft +
        ev.target.clientWidth / 2 -
        this.$refs.tabsLine.clientWidth / 2 +
        "px";
    },
    // 已付费/免费 点击播放
    // 播放条件在这里处理
    payVideo(item) {
      // 若没有item则为试看 给item赋值第一个试看的内容
      if(!item){
        for(let i=0,len=this.videoInfo_o.normalCourseVideos.length;i<len;i++){
          if(this.videoInfo_o.normalCourseVideos[i].isTrial === 'T'){
            item = this.videoInfo_o.normalCourseVideos[i];
            break;
          }
        }
      }
      // 判断是否需要登录 或 是否需要购买------------------
      if(!this.userId){ // 未登录
        if (item.type === 1) {
          // 免费视频只能看第一节，其余的都需登录观看
          if (item.id !== this.videoInfo_o.normalCourseVideos[0].id) {
            this.model('更多精彩视频需要登录才能观看！','login');
            return;
          }
        } else {
          // 付费视频只能观看试看&概要视频，其他都需要登录观看
          this.model('更多精彩视频需要登录才能观看！','login');
          return;
        }
      }
      // 判断是否特殊章节---------------------
      if (
        item.videoType !== 'O'    // 是否为概要：O概要 A选集
        && item.isTrial !== "T"     // 是否为试看
      ) {
        // 付费主体 1课程 2章节
        if (this.videoInfo_o.payBodyType === 1) {
          if (this.videoInfo_o.type === "T" && this.videoInfo_o.userCourseStatus === "B") {
            // 课程是否免费    // 课程是否购买
            this.model('该课程还未购买，是否前往购买？', 'unpaid', item.id);
            return;
          }
        } else if (this.videoInfo_o.payBodyType === 2) {
          if (item.type === 2 && item.payStatus === 'F') {
            // 章节需要付费  // 章节是否支付
            this.model('该课程还未购买，是否前往购买？', 'unpaid', item.id);
            return;
          }
        }
      }
      // 判断是否即将上线---------------------
      if (!item.video.vid) {
        // 即将上线
        this.model('课程即将上线，敬请期待！');
        return;
      }
      // 概要 || 试看
      if(item.videoType === "O" || item.isTrial === "T"){
        this.playVideo_fn(item);
      }else if(this.videoInfo_o.payBodyType === 1){
        // payBodyType付费主体 1课程 2章节
        // **userCourseStatus 用户对课程可操作状态 W 可观看(直接观看) B 未购买（可购买正常购买） O 有订单（存在未支付订单，根据orderId跳到订单详情页） G 正在参团中
        if(this.videoInfo_o.type === 'F' || this.videoInfo_o.userCourseStatus === 'W'){
          this.playVideo_fn(item);
        }
      }else if(this.videoInfo_o.payBodyType === 2){
        if(item.type === 1 || item.payStatus === 'T'){
          this.playVideo_fn(item);
        }
      }
    },

    // 播放视频
    playVideo_fn(item){
      // 判断是否显示支付完成样式
      if(this.videoInfo_o.payBodyType === 1){
        if(this.videoInfo_o.type === 'F' || this.videoInfo_o.userCourseStatus === 'W'){
          // 是否显示 已支付样式
          this.isPay_b = true;
        }
      }else if(this.videoInfo_o.payBodyType === 2){
        let isPay_temporary = true;
        this.videoInfo_o.normalCourseVideos.map(v=>{
          if(v.videoType !== 'O' && v.isTrial !== 'T' && v.payStatus === 'F'){
            isPay_temporary = false;
          }
        })
        if(isPay_temporary){
          this.isPay_b = true;
        }
      }

      this.isShowPlayer_b = true; // 是否显示播放器
      this.vid = item.video.vid; // 获取对应的vid
      this.videoId = item.video.id // 获取对应的ID
    },

    // 弹窗
    model(text,type,sectionId){
      let that = this;
      const modal = Modal.confirm({
        title: '提示',
        content: text?text:'更多精彩视频需要登录才能观看！',
        centered: true,
        maskClosable: true,
        okText: type === 'login' ? '登录' : '确定',
        onCancel() {},
        onOk() {
          if(type === 'login'){
            syslogin();
          }else if(type === 'unpaid'){
            that.$router.push({
              path:  '/pages/orderPay/orderPay',
              query: {
                courseId: that.videoInfo_o.id,
                section: sectionId
              }
            })
          }
        },
      });
    },

    // 获取视频详情
    getVideoInfo_fn() {
      getCourseDetail({
        courseId: this.curriculumId,
        userId: this.userId,
      }).then((res) => {
        if (res.data.code === 1) {
          this.videoInfo_o = res.data.data;
          console.log('课程详情', this.videoInfo_o)
          document.title = this.videoInfo_o.name;
          // 限时免费
          if(this.videoInfo_o.limitTimeFree === 'T' && this.videoInfo_o.userCourseStatus !== 'W'){
            // 结束时间
            let limitEndTime = new Date(this.videoInfo_o.limitEndTime);
            // 当前时间
            let nowDate = new Date();
            if(limitEndTime - nowDate>0){
              // 如果是限时免费直接改成已支付状态
              // this.userCourseStatus_copy = this.videoInfo_o.userCourseStatus;
              this.videoInfo_o.type = 'F'; // 改为免费 倒计时结束后重新获取课程信息
              // 开启倒计时
              this.limitTimeFree_countDown_fn();
            }
          }
          // 是否是免费课程
          // userCourseStatus 用户对课程可操作状态 W 可观看(直接观看) B 未购买（可购买正常购买） O 有订单（存在未支付订单，根据orderId跳到订单详情页） G 正在参团中
          // type 课程类型 其中F代表免费课程，T代表代币课程，M代表付费课程
          if(this.videoInfo_o.normalCourseVideos.length){
            if(this.videoInfo_o.payBodyType === 1){
              // 课程主体*********
              if(this.videoInfo_o.type === 'F' || this.videoInfo_o.userCourseStatus === 'W'){
                // 免费课程 || 已付费可直接播放
                this.isPay_b = true;
                this.isShowPlayer_b = true;
                // 根据传参播放指定视频
                if(this.$route.query.curriculum){
                  this.videoInfo_o.normalCourseVideos.map(v=>{
                    if(v.id == this.$route.query.curriculum){
                      this.vid = v.video.vid;
                      this.videoId = v.video.id;
                    }
                  })
                }else{
                  // 播放一个视频
                  this.vid = this.videoInfo_o.normalCourseVideos[0].video.vid;
                  this.videoId = this.videoInfo_o.normalCourseVideos[0].video.id
                }
              }else if(this.videoInfo_o.type === 'T'){
                // 规划有这种支付方式，但大佬们都说不会有这个类型，故不知道怎么操作
              }else if(this.videoInfo_o.type === "M"){
                // isShowPlayer_b: false, // 是否显示播放器
                // isPay_b: false, // 是否支付
                // 课程的用户状态 0:不可播放(默认) 1:可播放 2:未购买 3:有订单 4:正在参团
                // 付费课程
                switch (this.videoInfo_o.userCourseStatus) {
                  case "W":
                    // 付费课程已购买
                    this.isShowPlayer_b = true;
                    this.isPay_b = true;
                    // 播放一个视频
                    this.vid = this.videoInfo_o.normalCourseVideos[0].video.vid;
                    this.videoId = this.videoInfo_o.normalCourseVideos[0].video.id
                    break;
                  default:
                    this.isShowPlayer_b = false;
                    this.isPay_b = false;
                    break;
                }
              }
            }else{
              // 章节主体*******
              let whether_buy_all = true;
              this.videoInfo_o.normalCourseVideos.map(v=>{
                // 不是概述、不是试看、未支付
                if(v.videoType !== 'O' && v.isTrial !== 'T' && v.payStatus === 'F'){
                  whether_buy_all = false;
                }
              })
              if(whether_buy_all){
                this.isShowPlayer_b = true;
                this.isPay_b = true;
                // 播放一个视频
                this.vid = this.videoInfo_o.normalCourseVideos[0].video.vid;
                this.videoId = this.videoInfo_o.normalCourseVideos[0].video.id
              }
            }
          }
        } else {
          message.error({
            content:res.data.msg
          });
        }
      });
    },
    // 限时免费倒计时
    limitTimeFree_countDown_fn(){
      // 限免结束时间
      let limitEndTime = new Date(this.videoInfo_o.limitEndTime);
      this.limitTime_countDown_time = setInterval(() => {
        // 当前时间
        let nowDate = new Date();
        if (limitEndTime - nowDate > 0) {
          // 相差
          let t = limitEndTime - nowDate;
          let day = Math.floor(t/86400000);
          let hour = Math.floor((t/3600000)%24);
          let min = Math.floor((t/60000)%60);
          let sec = Math.floor((t/1000)%60);
          hour = hour < 10?'0' + hour: hour;
          min = min < 10?'0' + min: min;
          sec = sec < 10?'0' + sec: sec;
          if(day > 0){
            this.limitTime_countDown_text = `${day}:${hour}:${min}:${sec}`
          }else if(day<=0 && hour >0){
            this.limitTime_countDown_text = `${hour}:${min}:${sec}`
          }else if(day<=0 && hour <=0){
            this.limitTime_countDown_text = `${min}:${sec}`
          }
        }else{
          this.limitTime_countDown_text = '';
          this.videoInfo_o.userCourseStatus = this.userCourseStatus_copy;
          clearInterval(this.limitTime_countDown_time);
          this.getVideoInfo_fn();
        }
      }, 1000);
    },
    // 获取用户对当前课程的各种状态（是否收藏，是否评分，是否点赞，是否购买）
    getUserCourseStatus_fn(){
      getUserCourseStatus({
        courseId: this.curriculumId,
        userId: this.userId,
      }).then(res=>{
        if(res.data.code === 1){
          if(res.data.data.isCollect === 'T'){
            this.isCollect_b = true;
          }else{
            this.isCollect_b = false;
          }

          // 暂时先不写评分功能
          if(res.data.data.isScore === "T"){
            this.isScore_b = false;
          }else{
            this.isScore_b = false;
          }
        }
      })
    },
    // 收藏视频
    videoCollect_fn(){
      if(!this.userId){
        this.model('您还未登录，请先登录。','login');
        return;
      }
      add_to_favorite('','','',[],'','','',[],'','',String(this.curriculumId),'','课程收藏',String(this.videoInfo_o.name))
      courseCollect({
        courseId: this.curriculumId,
        collectorId: this.userId
      }).then((res)=>{
        if(res.code === 1){
          if(this.isCollect_b){
            this.isCollect_b = false;
            message.success('取消课程收藏')
          }else{
            this.isCollect_b = true;
            message.success('课程收藏成功');
          }
        }
      })
    },
    // 浏览量+1
    savePlayRecord_fn(activeVid){
      let videoId = null;
      this.videoInfo_o.normalCourseVideos.map(v=>{
        if(v.video.vid === activeVid){
          videoId = v.video.id;
        }
      })
      savePlayRecord({
        courseId: this.curriculumId,
        videoId: videoId,
        playerId: this.userId,
      })
    },
    /**

    **@desc: 采集云课堂浏览历史

    **@date:2022/6/22 10:53

    **@author:Rick

    **@method:beforeunloadHandler

    **@params:

    */
    beforeunloadHandler(type){
      const ajaxUrl =  process.env.NODE_ENV === "production" ? (/\/\/www\./.test(window.location.origin) ? baseUrl.pro : baseUrl.dev) : baseUrl.dev
      const url = ajaxUrl +"/v1/cms/saveBrowsingHistory.jspx" // 请求地址
      /**
       * 获取视频的播放时间
       * @type {string}
       */
      let data  // 数据
      if((this.videoId || this.vid) && type === "beforeunload"){
        /**
         * 如果是页面销毁 则获取视频播放时间
         */
        var videoTime = document.querySelector("video");
        const videoTime_currentTime = videoTime.currentTime // 获取视频当前播放时间
        data ={
          loginUserId:this.userId, // this.userId
          contentSource:11,  // 2是课程视频  11是云课堂视频
          contentId:this.videoId,
          courseId:this.curriculumId,
          playDuration:videoTime_currentTime ? Math.trunc(videoTime_currentTime) : 0
        }
      }else{
        /**
         * 采集云课堂课程
         * @type {{contentSource: number, playDuration: string, contentId: string | RouteParamValue[], loginUserId: number, courseId: string | RouteParamValue[]}}
         */
        data = {
          loginUserId: this.userId, // this.userId
          contentSource: 2,  // 2是课程视频  11是云课堂视频
          contentId: this.curriculumId,
          courseId: this.curriculumId,
          playDuration: ""
        }
      }
      // 新建formData数据
      const formData = new FormData();
      //数据转换
      Object.keys(data).forEach((key) => {
        let value = data[key];
        if (typeof value !== "string") {
          // formData只能append string 或 Blob
          value = JSON.stringify(value);
        }
        formData.append(key, value);
      });
      // navigator.sendBeacon(url,formData)
      this.userId ?  navigator.sendBeacon(url,formData) : null
    }
  },
  mounted() {
    /**

    **@desc: 浏览器默认采集课程视频

    **@date:2022/6/22 11:40

    **@author:Rick

    **@method:mounted

    **@params:

    */
    this.beforeunloadHandler()
    /**
     *  beforeunload 窗口卸载
        pagehide
     */
    window.addEventListener("beforeunload",() =>  this.beforeunloadHandler("beforeunload"))
    // saveBrowsingHistory({
    //   loginUserId:55185, // this.userId
    //   contentSource:2,
    //   contentId:this.curriculumId,
    //   courseId:"",
    //   playDuration:""
    // }).then(res=>{
    //   console.log(res);
    // })

    this.getVideoInfo_fn(); // 获取课程信息
    this.getUserCourseStatus_fn(); // 获取相关状态
  },
  watch:{
    // 监听路由刷新页面
    $route(n,o){
      if(o.path === n.path){
        this.getVideoInfo_fn(); // 获取课程信息
        this.getUserCourseStatus_fn(); // 获取用户各种状态（是否收藏，是否评分，是否点赞，是否购买）
      }
    },
    vid:{
      handler(n,o){
        // 浏览+1
        this.savePlayRecord_fn(this.vid); // 增加浏览量
      },
      deep:true
    }
  },
  beforeUnmount() {
    console.log("组件销毁");
    /**

    **@desc: 移出监听

    **@date:2022/6/22 11:33

    **@author:Rick

    **@method:onUnmounted

    **@params:

    */
    this.beforeunloadHandler("beforeunload")
    clearInterval(this.limitTime_countDown_time);
    window.removeEventListener("beforeunload", () => this.beforeunloadHandler());
  }
};
</script>

<style scoped lang="scss">
.course {
  @extend %safetyWidth;
  display: flex;
}

.tabList {
  background: #f5f5f5;
  height: 64px;
  margin-top: 20px;
  margin-bottom: 20px;
  user-select: none;

  nav {
    @extend %safetyWidth;
    position: relative;

    .tabsLine {
      width: 40px;
      height: 4px;
      background: $theme_blue;
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 16px;
      transition: all 0.3s;
    }
  }

  ul {
    display: flex;

    li {
      margin-right: 30px;
      font-size: 18px;
      line-height: 64px;
      cursor: pointer;
      color: #708AA2;

      &.active{
        color: #000;
      }
    }
  }
}

.content {
  @extend %safetyWidth;
  display: flex;
}

.outherCourse {
  flex: 1;
  width: 0;
  display: flex;
  flex-direction: column;

  .item {
    @extend %defaultBg;
    width: 100%;
    border-radius: 6px;
    padding: 20px 15px;
    transition: all .3s;

    h3 {
      font-size: 20px;
      position: relative;
      padding-left: 10px;

      &::after {
        content: "";
        display: inline-block;
        position: absolute;
        width: 3px;
        height: 16px;
        background: $theme_blue;
        top: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        border-radius: 4px;
      }
    }
  }

  .author {
    margin-bottom: 20px;

    .authorMain {
      display: flex;
      margin-top: 16px;

      img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        background: #8a8a8a;
        margin-right: 12px;
        object-fit: cover;
      }

      div {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        span {
          font-size: 26px;
        }

        i {
          font-size: 20px;
          color: #707070;
        }
      }
    }
  }

  .related {
    ul {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      height:520px;

      .relatedList {
        display: flex;
        margin-bottom: 14px;
        cursor: pointer;

        img {
          width: 160px;
          height: 90px;
          background: #364d79;
          border-radius: 6px;
          margin-right: 14px;
        }

        div {
          display: flex;
          flex-direction: column;
          flex: 1;
          width: 0;

          h5 {
            font-size: 16px;
            color: #000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          p{
            display: flex;
            flex-wrap: wrap;

            b {
              font-size: 14px;
              color: #333;
              font-weight: normal;
              margin-right: 10px;
            }
          }



          i {
            font-size: 12px;
            color: #708aa2;
            margin-top: auto;
          }
        }
      }
    }
  }
}
</style>
